import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './rootReducer';
import { composeWithDevTools } from 'redux-devtools-extension';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import { userLoggedIn } from './actions';
import jwtDecode from 'jwt-decode';

const offlinePluginRuntime = require('offline-plugin/runtime')
offlinePluginRuntime.install()

const store = createStore(
    rootReducer,
    composeWithDevTools(
        applyMiddleware(thunk)
    )
);

if (localStorage.token) {
    // change to session if we want it to expire or go when the window is closed
    store.dispatch(userLoggedIn(jwtDecode(localStorage.token)));
}

ReactDOM.render( 
<BrowserRouter>
    <Provider store={store}>
    <App />
    </Provider> 
</BrowserRouter>,
 document.getElementById('root')
);


// WEBPACK FOOTER //
// ./src/index.js